import { useMemo } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import SectionDetails from '../../_Sections/SectionDetails';
import SectionGallery from '../../_Sections/SectionGallery';
import SectionDropship from '../../_Sections/SectionDropship';
import SectionPairings from '../../_Sections/SectionPairings';
import SectionBranding from '../../_Sections/SectionBranding';
import SectionSizes from '../../_Sections/SectionSizes';
import { useSelector } from 'react-redux';
import WebsiteStore from '../../../WebsiteStore';
import { styled } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import SectionPricing from '../../_Sections/SectionPricing';
import tKey from '../../../Common/Utils/tKey';
import { useAppSelector } from '../../../Common/_hooks/useAppSelector';
import ProductSEO from '../../_Sections/ProductSEO';

const PRODUCT_ID = 36;
const VIEW_PRODUCT_ID = 34;

export default function FlareDressPage() {
  const [t] = useTranslation('page/products/flare-dress');
  const productData = useAppSelector(state => state.get('appData').get('products').get(String(PRODUCT_ID)));
  const locale = useAppSelector(state => state.get('userData').get('prefs').get('lang'))

  if (!productData) return null

  return <div className="centered-page product-page-v4">
    <ProductSEO
      viewProductId={VIEW_PRODUCT_ID}
      title={t('Custom all-over print Flare Dress | Products')}
      description={t('Design and create your own custom printed Flare Dress featuring your artwork. ✔ Print-on-demand drop shipping ✔ No minimums ✔ Made in Canada')}
    />
    <SectionDetails
      viewProductId={VIEW_PRODUCT_ID}
      color="#d7d967"
      bgStyle={{
        backgroundPosition: 'bottom right',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '37%',
      }}
      tag={t('The all-over print')}
      title={t('Flare Dress')}
      text={t('Make a statement in custom all-over print flared dresses made on-demand in Montreal, Canada. Featuring a tailored bodice and A-line skirt that falls mid-thigh, these dresses are crafted from ultrasoft Luxeform fabric. With radiant, enduring prints, your designs stay vivid through every wear and wash.')}
      createUrl={productData.get('url_slug') + '?option_fabric=performance-knit'}
      img={require('@resources/img/pages/products/flare-dress/banner-1-' + locale + '.png')}
      alt={t('Picture of Flare Dress')}
      details={[
        {
          img: require('@resources/img/pages/products/flare-dress/icon-1.svg?url'),
          alt: t('icon'),
          text: t('Fitted bodice and flared A-line skirt. '),
        },
        {
          img: require('@resources/img/pages/products/flare-dress/icon-2.svg?url'),
          alt: t('icon'),
          text: t('Made from Luxeform performance fabric: combining the power of spandex with lightness and comfort'),
        },
        {
          img: require('@resources/img/pages/products/flare-dress/icon-3.svg?url'),
          alt: t('icon'),
          text: t('Falls mid-thigh'),
        },
        {
          img: require('@resources/img/pages/products/flare-dress/icon-4.svg?url'),
          alt: t('icon'),
          text: t('Vibrant, permanent prints won’t fade with use or washing'),
        },
        {
          img: require('@resources/img/pages/products/flare-dress/icon-5.svg?url'),
          alt: t('icon'),
          text: t('Digitally printed on demand in Montreal, Canada'),
        },
      ]}
    />
    <SectionGallery images={[
      require('@resources/img/pages/products/flare-dress/gallery_0.jpg'),
      require('@resources/img/pages/products/flare-dress/gallery_1.jpg'),
      require('@resources/img/pages/products/flare-dress/gallery_2.jpg'),
      require('@resources/img/pages/products/flare-dress/gallery_3.jpg'),
      require('@resources/img/pages/products/flare-dress/gallery_4.jpg'),
    ]} />

    <SectionDropship
      title={<Trans
        t={t}
        i18nKey={tKey('<yellow>Drop ship</yellow> your <br/>flare Dress <pink>on-demand</pink>')}
        components={{
          yellow: <span className="ty" />,
          pink: <span className="tp" />,
        }}
      />}
      text={t('Your brand and following will love Flare Dress! At prices designed for reselling, Flare Dress made on demand meet the needs of sellers who prefer not to stock inventory. Sell them in your eCommerce store and decide your profit margin')}
    />

    <SectionPricing
      productId={PRODUCT_ID}
      options={['performance-knit']}
    />

    <SectionSizes
      chart="full"
      productId={PRODUCT_ID}
      title={t('Flare Dress Sizing')}
      text={t('All measurements are approximate. Since our products are made by hand, there may be variations in the finished size of our products between orders or even within an order.')}
    />

    <SectionBranding
      hasLabel
      title={t('Brand your Flare Dress')}
      text={t('Branding enhances your products. Add custom labels, artist cards or stickers to your packages to create a cohesive message and build your brand.')}
    />

    <SectionPairings
      text={t('Pair your Flare Dress with these great products to create your own unique styles.')}
      productSlugs={['cropped-pullover-hoodie', 'athletic-crop-top', 'kimono-robe-peachskin']}
    />
  </div>
}